/**
 * /frontend/src/features/analytics/components/offers/OfferEngagementTrendChart.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import TrendLineChart from '../charts/TrendLineChart';
import { CHART_COLORS } from '../../constants/chartColors';

/**
 * Offer engagement trend chart.
 * @param {{data:Array<{label:string,claims:number,redemptions:number}>}} props
 * @returns {JSX.Element}
 */
const OfferEngagementTrendChart = ({ data }) => {
  const lines = useMemo(() => ([
    { key: 'claims', label: 'Claims', color: CHART_COLORS.accent },
    { key: 'redemptions', label: 'Redemptions', color: CHART_COLORS.success }
  ]), []);

  return (
    <ChartContainer title="Offer Engagement Trend" subtitle="Claims and redemptions over time">
      <TrendLineChart data={data} xKey="label" lines={lines} />
    </ChartContainer>
  );
};

export default OfferEngagementTrendChart;

